export const disclaimer = {
  title: 'disclaimer-title',
};
